// File: /src/components/InvoiceForm.js

import React, { useState } from 'react';
import '../styles/InvoiceForm.css';

const InvoiceForm = ({
	form,
	handleInputChange,
	addOrUpdateInvoice,
	projects,
	editingInvoice,
}) => {
	const [dateError, setDateError] = useState('');
	const [dateInputValue, setDateInputValue] = useState(
		form.due_date ? form.due_date.toLocaleDateString('pt-BR') : ''
	);

	const formatDateInput = (value) => {
		const digits = value.replace(/\D/g, '');
		let formatted = digits;
		if (digits.length > 2) {
			formatted = digits.slice(0, 2) + '/' + digits.slice(2);
		}
		if (digits.length > 4) {
			formatted =
				digits.slice(0, 2) +
				'/' +
				digits.slice(2, 4) +
				'/' +
				digits.slice(4, 8);
		}
		return formatted;
	};

	const validateDate = (dateStr) => {
		if (dateStr.length === 0) return true;
		const regex = /^(\d{2})\/(\d{2})\/(\d{4})$/;
		if (!regex.test(dateStr)) return false;
		const [, day, month, year] = dateStr.match(regex);
		const date = new Date(year, month - 1, day);
		return (
			date &&
			date.getFullYear() === Number(year) &&
			date.getMonth() === Number(month) - 1 &&
			date.getDate() === Number(day)
		);
	};

	const handleDateChange = (e) => {
		const rawValue = e.target.value;
		const formattedValue = formatDateInput(rawValue);
		setDateInputValue(formattedValue);

		if (!validateDate(formattedValue)) {
			setDateError('Data inválida');
			handleInputChange({
				target: { name: 'due_date', value: null },
			});
		} else {
			setDateError('');
			if (formattedValue.length === 10) {
				const [day, month, year] = formattedValue.split('/');
				const date = new Date(year, month - 1, day);
				handleInputChange({
					target: { name: 'due_date', value: date },
				});
			}
		}
	};

	return (
		<form
			className="invoice-form"
			onSubmit={addOrUpdateInvoice}
			autoComplete="off"
		>
			<h2 className="form-title">
				{editingInvoice ? 'EDITAR FATURA' : 'ADICIONAR FATURA'}
			</h2>
			<div className="form-field">
				<label>Projeto</label>
				<select
					name="projectId"
					value={form.projectId}
					onChange={handleInputChange}
					required
				>
					<option value="">Selecione um Projeto</option>
					{projects.map((project) => (
						<option key={project.id} value={project.id}>
							{project.id} - {project.name}
						</option>
					))}
				</select>
			</div>

			<div className="form-field">
				<label>Descrição</label>
				<textarea
					name="description"
					placeholder="Digite a descrição da fatura"
					value={form.description ?? ''}
					onChange={handleInputChange}
					rows={3}
				/>
			</div>

			<div className="form-field">
				<label>Valor</label>
				<input
					name="value"
					type="number"
					placeholder="Digite o valor"
					value={form.value}
					onChange={handleInputChange}
					required
				/>
			</div>

			<div className="form-field">
				<label>Data de Vencimento</label>
				<div className="date-input-container">
					<input
						name="due_date"
						type="text"
						placeholder="DD/MM/AAAA"
						value={dateInputValue}
						onChange={handleDateChange}
						required
						autoComplete="off"
					/>
					{dateError && <span className="date-error">{dateError}</span>}
				</div>
			</div>

			<div className="form-field">
				<label>Status</label>
				<select
					name="status"
					value={form.status}
					onChange={handleInputChange}
					required
				>
					<option value="pending">Pendente</option>
					<option value="paid">Pago</option>
					<option value="overdue">Atrasado</option>
				</select>
			</div>

			<button type="submit">
				{editingInvoice ? 'Salvar Alterações' : 'Adicionar Fatura'}
			</button>
		</form>
	);
};

export default InvoiceForm;
